import React from "react";
import "../css/ChooseUs.css";

const ChooseUs = () => {
  return (
    <section className="chooseus-section" aria-labelledby="chooseus-heading">
      <div className="chooseus-inner">
        {/* Left column: pretitle + heading */}
        <div className="chooseus-left">
          <div className="chooseus-pre">WHY CHOOSE US</div>
          <h2 id="chooseus-heading" className="chooseus-title">
            Unique Value Propositions <br />
            That Set Us Apart
          </h2>
        </div>

        {/* Right column: 2x2 cards inside a rounded container */}
        <div className="chooseus-right">
          <div className="cards-wrapper" role="list">
            <article className="feature-card" role="listitem" aria-label="Expert Technicians">
              <div className="card-number">01</div>
              <h3 className="card-title">Expert Technicians</h3>
              <p className="card-text">
                Our skilled team delivers reliable and knowledgeable air conditioning services tailored to your needs.
              </p>
            </article>

            <article className="feature-card" role="listitem" aria-label="90 Day Service Warranty">
              <div className="card-number">02</div>
              <h3 className="card-title">90 Day Service Warranty</h3>
              <p className="card-text">
                Get peace of mind with our 90–day warranty on repairs and service.
              </p>
            </article>

            <article className="feature-card" role="listitem" aria-label="Prompt Service">
              <div className="card-number">03</div>
              <h3 className="card-title">Prompt Service</h3>
              <p className="card-text">
                Count on us for quick response times and efficient solutions to all your AC needs.
              </p>
            </article>

            <article className="feature-card" role="listitem" aria-label="Affordable Pricing">
              <div className="card-number">04</div>
              <h3 className="card-title">Affordable And Transparent Pricing</h3>
              <p className="card-text">
                We provide quality service at affordable price. There is no hidden charges.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseUs;
